(ns bec-core.cljs.core
  (:require [bec-core.cljs.config :as config]
            [reagent.dom :as r-dom]
            [re-frame.core :as rf]
            [cljs.core.async.interop :refer-macros [<p!]]
            [ajax.core :as ajax]
            [taoensso.timbre :as log]
            [bec-cljs-common.utils.css :as bcc.css]
            [bec-cljs-common.utils.visibility :as visibility]
            [bec-cljs-common.config :as bcc.config]
            [bec-cljs-common.networking :as bcc.net]
            [bec-cljs-common.logging :as bcc.log]
            [bec-cljs-common.url]
            [bec-cljs-common.state-sync-client :as bcc.sss]
            [bec-cljs-common.pushyme :as pushyme]
            [bec-core.cljs.events]
            [bec-core.cljs.subs]
            [bec-core.cljs.effects]
            [bec-core.cljs.views :as views]
            [bec-core.cljs.routes :as routes]
            [bec-core.cljs.service-worker :as sw]
            #_[bec-core.cljs.connection :as connection]
            [bec-core.cljs.notification :as notification]))


(defn start []
  (rf/clear-subscription-cache!)
  (r-dom/render [views/main]
                (js/document.getElementById "app")))


(defn ^:export init []
  ;; init is called ONCE when the page loads
  ;; this is called in the index.html and must be exported
  ;; so it is available even in :advanced release builds
  (bcc.log/configure-logging (config/get-bec-core-server-url) bcc.config/app-type)
  (rf/dispatch-sync [:initialize-db])

  (bcc.net/start-sse bcc.config/client-state-path
                     (str (config/get-bec-core-server-url)
                          (bcc.net/sse-url bcc.config/stream-name bcc.config/viewport-id "stream"))
                     (fn []
                       (ajax/PUT (str (config/get-bec-core-server-url)
                                      (bcc.net/sse-url bcc.config/stream-name bcc.config/viewport-id "resync"))
                                 {:error-handler (fn [& args] (log/warn 'resync-cb args))})))

  (routes/add-popstate-listener)

  ;; (connection/add-listeners)

  (bcc.css/theme-listener)
  (bcc.css/display-mode-listener)

  (start)

  ;; service worker
  ;; (sw/activate) ;; TODO: This somehow sets things up so AC, CC and MC opened on the same IP (at least once) as b-c-client starts making constant requests to /bec-core-server/ type URIs for some reason. Disabled for now. -- lnostdal

  (notification/request-permission)
  ;; (notification/create)
  (pushyme/register! "6283fe4fca130a4f54f56a41")
  (visibility/add-listener))


(defn stop []
  ;; stop is called before any code is reloaded
  ;; this is controlled by :before-load in the config
  (js/console.log "stop"))
